import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const CreateOrderForm = props => {
  const createBtn = (
    <div className="createorderform-wrapper">
      <button
        className="createorderform-button"
        type="button"
        onClick={() => props.openCreateDocumentPopup(props.quote, true)}
        data-test="createorderformcard-btn">
        <FontAwesomeIcon
          icon={["far", "exclamation-triangle"]}
          className="createorderform-icon"
        />
        <span className="createorderform-title">{props.quote.name}</span>
        <span className="createorderform-subtitle">
          +Create Order form with this qoute
        </span>
      </button>
    </div>
  );
  return createBtn;
};

export default CreateOrderForm;
